const en = {
  nav: {
    home: 'Home',
    services: 'Services',
    about: 'About',
    contact: 'Contact',
  },
  hero: {
    tagline: 'ARTIFICIAL INTELLIGENCE • SOFTWARE SOLUTIONS • INNOVATION',
    title: "Engineering Tomorrow's",
    titleHighlight: 'Intelligence',
    subtitle: 'Pioneering AI solutions, data analytics, and intelligent software systems since 2015. We transform complex challenges into elegant technological solutions.',
    cta: 'Explore Our Work',
    ctaSecondary: 'Get in Touch',
  },
  services: {
    title: 'Our Expertise',
    subtitle: 'Comprehensive AI and software solutions tailored for enterprise excellence',
    items: [
      {
        icon: '◇',
        title: 'Artificial Intelligence',
        description: 'Custom AI models, machine learning pipelines, and intelligent automation systems designed for your specific business needs.',
      },
      {
        icon: '△',
        title: 'Data Mining & Analytics',
        description: 'Extract actionable insights from your data with advanced analytics, predictive modeling, and business intelligence solutions.',
      },
      {
        icon: '○',
        title: 'Natural Language Processing',
        description: 'Text analysis, sentiment detection, chatbots, and language understanding systems for Persian and English.',
      },
      {
        icon: '□',
        title: 'Computer Vision',
        description: 'Image recognition, object detection, video analytics, and visual inspection systems for industrial applications.',
      },
      {
        icon: '◈',
        title: 'Robotics & Simulation',
        description: 'Robotic process automation, digital twins, and virtual reality solutions for training and visualization.',
      },
      {
        icon: '⬡',
        title: 'Software Development',
        description: 'Full-stack web and mobile applications, enterprise systems, and custom software tailored to your workflow.',
      },
    ],
  },
  about: {
    title: 'About Arma Rayan Borna',
    p1: 'Established in 2015, Arma Rayan Borna is a leading Iranian technology company specializing in artificial intelligence and comprehensive IT solutions. We serve both public and private sectors, including government ministries, organizations, and enterprises.',
    p2: 'Our team combines deep technical expertise with practical business understanding to deliver solutions that drive real value. From concept to deployment to ongoing support, we partner with our clients throughout their digital transformation journey.',
    p3: 'We actively collaborate with domestic and international partners to bring world-class technology solutions to the Iranian market while also expanding our services globally.',
    stats: [
      { number: '2015', label: 'Founded' },
      { number: '100+', label: 'Projects Delivered' },
      { number: '50+', label: 'Enterprise Clients' },
      { number: '24/7', label: 'Support' },
    ],
  },
  contact: {
    title: "Let's Build Together",
    subtitle: 'Ready to transform your business with intelligent solutions? Reach out to our team.',
    address: 'Address',
    addressValue: 'No. 23, Behrouz Rezaei St., Nahid St., Marzdaran Ave., Tehran, Iran',
    postalCode: 'Postal Code: 1461785791',
    email: 'Email',
    phone: 'Phone',
    form: {
      name: 'Your Name',
      email: 'Your Email',
      message: 'Your Message',
      submit: 'Send Message',
      sending: 'Sending...',
      success: 'Message sent successfully!',
      error: 'Failed to send. Please try again.',
    },
  },
  footer: {
    copyright: '© 2024 Arma Rayan Borna. All rights reserved.',
    registration: 'Registration No. 482176 | National ID: 14005374915',
    links: {
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
    },
  },
  privacy: {
    title: 'Privacy Policy',
    backToHome: 'Back to Home',
    lastUpdated: 'Last Updated: December 2024',
    introduction: {
      title: '1. Introduction',
      content: 'Arma Rayan Borna ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services. By accessing our website, you agree to the collection and use of information in accordance with this policy.',
    },
    informationCollection: {
      title: '2. Information We Collect',
      intro: 'We may collect information about you in a variety of ways. The information we may collect includes:',
      items: [
        'Personal identification information (name, email address, phone number) when you contact us or use our services',
        'Technical data such as IP address, browser type, device information, and usage patterns',
        'Cookies and tracking technologies to enhance your browsing experience',
        'Information you voluntarily provide through forms, surveys, or communications with us',
      ],
    },
    useOfInformation: {
      title: '3. How We Use Your Information',
      intro: 'We use the information we collect for various purposes, including:',
      items: [
        'To provide, maintain, and improve our services',
        'To respond to your inquiries, comments, or requests',
        'To send you technical notices, updates, and support messages',
        'To monitor and analyze usage patterns and trends',
        'To detect, prevent, and address technical issues or security threats',
        'To comply with legal obligations and protect our rights',
      ],
    },
    dataSecurity: {
      title: '4. Data Security',
      content: 'We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.',
    },
    cookies: {
      title: '5. Cookies and Tracking Technologies',
      content: 'We use cookies and similar tracking technologies to track activity on our website and store certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our website.',
    },
    userRights: {
      title: '6. Your Rights',
      intro: 'You have certain rights regarding your personal information, including:',
      items: [
        'The right to access and receive a copy of your personal data',
        'The right to rectify inaccurate or incomplete information',
        'The right to request deletion of your personal information',
        'The right to object to processing of your personal data',
        'The right to data portability',
        'The right to withdraw consent at any time',
      ],
    },
    changesToPolicy: {
      title: '7. Changes to This Privacy Policy',
      content: 'We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. You are advised to review this Privacy Policy periodically for any changes.',
    },
    contactInformation: {
      title: '8. Contact Us',
      content: 'If you have any questions about this Privacy Policy or our data practices, please contact us:',
      email: 'Email',
      address: 'Address',
    },
  },
  terms: {
    title: 'Terms of Service',
    backToHome: 'Back to Home',
    lastUpdated: 'Last Updated: December 2024',
    acceptanceOfTerms: {
      title: '1. Acceptance of Terms',
      content: 'By accessing and using the Arma Rayan Borna website and services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.',
    },
    servicesDescription: {
      title: '2. Services Description',
      content: 'Arma Rayan Borna provides artificial intelligence solutions, software development, data analytics, and related technology services. We reserve the right to modify, suspend, or discontinue any aspect of our services at any time without prior notice.',
    },
    userObligations: {
      title: '3. User Obligations',
      intro: 'When using our services, you agree to:',
      items: [
        'Provide accurate, current, and complete information when required',
        'Maintain the security of your account credentials and notify us of any unauthorized use',
        'Use our services only for lawful purposes and in accordance with these Terms',
        'Not attempt to gain unauthorized access to our systems or interfere with service operations',
        'Not use our services to transmit any harmful, offensive, or illegal content',
        'Respect intellectual property rights and not infringe upon the rights of others',
      ],
    },
    intellectualProperty: {
      title: '4. Intellectual Property',
      content: 'All content, features, and functionality of our website and services, including but not limited to text, graphics, logos, software, and designs, are owned by Arma Rayan Borna and are protected by international copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission.',
    },
    limitationOfLiability: {
      title: '5. Limitation of Liability',
      content: 'To the fullest extent permitted by law, Arma Rayan Borna shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your use of our services.',
    },
    termination: {
      title: '6. Termination',
      content: 'We reserve the right to terminate or suspend your access to our services immediately, without prior notice or liability, for any reason, including without limitation if you breach the Terms. Upon termination, your right to use the services will immediately cease.',
    },
    governingLaw: {
      title: '7. Governing Law',
      content: 'These Terms shall be governed by and construed in accordance with the laws of the Islamic Republic of Iran, without regard to its conflict of law provisions. Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts of Tehran, Iran.',
    },
    contactInformation: {
      title: '8. Contact Information',
      content: 'If you have any questions about these Terms of Service, please contact us:',
      email: 'Email',
      address: 'Address',
    },
  },
};

export default en;
